import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import Steps from "../Tools/Steps";
import Address from "../Inputs/Address";
import { LoadingButton } from "@mui/lab";
import Detail from "./Detail";
import Layout from "../Frames/Layout";
import API from "../../services/API";
import { useNavigate } from "react-router-dom";

export default function Form(){

    const navigate = useNavigate()

    const [order, setOrder] = useState({
        user: {country: 'FR'},
        products: [],
        reference: null,
        comment: null
    })

    const [step, setStep] = useState(0)
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const stepIs = s => s === step

    const handleUserChange = e => {
        let copy = JSON.parse(JSON.stringify(order))
        copy.user[e.target.name] = e.target.value;
        setOrder(copy)
    }

    const handleSubmit = e => {
        e.preventDefault();

        if(!validate()) return false;

        if(stepIs(0)) return handleEmail();

        if(stepIs(3)) return handleConfirm();

        return setStep(step + 1);
    }

    const validate = () => {

        let e = {};

        if(stepIs(2)){
            if(order.products.length === 0) e.products = "Vous devez ajouter au moins un article";
        }

        setErrors(e)

        return Object.keys(e).length === 0;
    }

    const handleEmail = () => {

        setLoading(true)
        
        API.get(`/crm/users/${order.user?.email}`)
            .then(r => setOrder({...order, user: r.data}))
            .catch(e => console.log(e.response))
            .finally(() => {
                setLoading(false)
                setStep(step + 1)
            })
    }

    const handleConfirm = () => {

        setLoading(true)

        API.post(`/orders`, order)
            .then(r => navigate('/crm/orders'))
            .catch(e => {
                console.log(e.response)
                setErrors({...errors, confirm: "Une erreur s'est produite. Veuillez vérifier les informations de la commande."})
                setLoading(false)
            })
    }


    return <Layout tab='orders' title='' menu='crm' back>
        
        <Stack direction='column' spacing={3} sx={{maxWidth: 700, margin: 'auto'}}>

            <Typography variant='h1'>Créer une commande</Typography>

            <Steps 
                value={step}
                onChange={step => setStep(step)}
                length={4}
            />


            {stepIs(0) && <StepForm onSubmit={handleSubmit} loading={loading}>
            
                <TextField 
                    name='email'
                    label='Email du client'
                    value={order.user.email || ''}
                    onChange={handleUserChange}
                    inputProps={{maxLength: 100}}
                    required
                    helperText="Si le contact existe, ses coordonnées seront préchargées"
                    size='small'
                />

            </StepForm>}


            {stepIs(1) && <StepForm onSubmit={handleSubmit} onPrevious={() => setStep(step - 1)}>

                <TextField 
                    name='lastName'
                    label='Nom du client'
                    value={order.user.lastName || ''}
                    onChange={handleUserChange}
                    inputProps={{maxLength: 250}}
                    required
                    size='small'
                />

                <TextField 
                    name='firstName'
                    label='Prénom'
                    value={order.user.firstName || ''}
                    onChange={handleUserChange}
                    inputProps={{maxLength: 250}}
                    size='small'
                />

                <TextField 
                    name='phone'
                    label='Téléphone'
                    value={order.user.phone || ''}
                    onChange={handleUserChange}
                    inputProps={{maxLength: 20}}
                    size='small'
                />

                <Address
                    value={order.user}
                    onChange={data => setOrder({...order, user: data})}
                    required
                />

            </StepForm>}


            {stepIs(2) && <>

                {errors.products && 
                    <Alert severity="error">{errors.products}</Alert>
                }

                <Detail 
                    order={order} 
                    edit
                    onChange={order => setOrder(order)}
                />

                <StepForm onSubmit={handleSubmit} onPrevious={() => setStep(step - 1)}/>

            </>}
            

            {stepIs(3) && <StepForm 
                    onSubmit={handleSubmit} 
                    onPrevious={() => setStep(step - 1)} 
                    final 
                    loading={loading}
                >

                {errors.confirm && 
                    <Alert severity='error'>{errors.confirm}</Alert>
                }

                <TextField 
                    label='Référence de la commande'
                    value={order.reference || ''}
                    onChange={e => setOrder({...order, reference: e.target.value})}
                    inputProps={{maxLength: 100}}
                    helperText="Ex. : Numéro de dossier OPCO"
                    size='small'
                />

                <TextField 
                    label='Commentaire'
                    value={order.comment || ''}
                    onChange={e => setOrder({...order, comment: e.target.value})}
                    inputProps={{maxLength: 500}}
                    helperText="Informations additionnelles pour la facture"
                    multiline
                    minRows={3}
                    size='small'
                />

            </StepForm>}

            

        </Stack>

    </Layout>
}


function StepForm({onSubmit, onPrevious, loading, final, children}){

    return  <form onSubmit={onSubmit}>

        <Stack direction='column' spacing={2} sx={{mt: 2}}>

            {children}

            <Stack direction='row' justifyContent='space-between'>

                {onPrevious ?
                    <Button 
                        variant='outlined'
                        onClick={onPrevious}
                    >
                        Précédent
                    </Button>
                    :
                    <div></div>
                }

                <LoadingButton
                    type='submit'
                    loading={loading}
                    variant='contained'
                    onClick={onSubmit}
                >
                    {final ? "Confirmer" : "Suivant"}
                </LoadingButton>

            </Stack>

        </Stack>

    </form> 
    
}